<template>
  <div class="breadcrumb">
    <ul>
      <li
        v-for="(breadcrumb, idx) in breadcrumbList"
        :key="idx"
        :class="{ linked: !!breadcrumb.link }"
        @click="routeTo(idx)"
      >
        {{ breadcrumb.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  data() {
    return {
      breadcrumbList: [],
    };
  },
  watch: {
    $route() {
      this.updateList();
    },
  },
  mounted() {
    this.updateList();
  },
  methods: {
    routeTo(pRouteTo) {
      if (this.breadcrumbList[pRouteTo].link)
        this.$router.push(this.breadcrumbList[pRouteTo].link);
    },
    updateList() {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  background-color: transparent;
  border-bottom: solid 1px $color_black_border;
  border-radius: 0;
  width: 100%;
  padding-top: 30px;
}
ul {
  display: flex;
  list-style: none;
  padding: 0;
  font-size: font(1);
}

li {
  cursor: pointer;
  color: $color_black_inactive;
  font-weight: 300;
  font-size: 18px;
}

li:last-child {
  cursor: default;
  color: $color_black;
}

li:not(:last-child):after {
  content: ">";
  margin: 10px;
}

@media (max-width: 991px) {
  li {
    font-size: 14px;
  }
}

@media (max-width: 767px) {
  li {
    font-size: 20px;
  }
}

@media (max-width: 575px) {
  li {
    font-size: 3.5vw;
  }
}
</style>
